// extracted by mini-css-extract-plugin
export const headline = "properties-module--headline--f-IYX";
export const properties = "properties-module--properties--2DOvk";
export const property = "properties-module--property--1AiVt";
export const property__details = "properties-module--property__details--2RsqP";
export const property__type = "properties-module--property__type--hCdB7";
export const propertyWrapper = "properties-module--propertyWrapper--23bvU";